import { useWrapRequest } from 'use-wrap-request';
import { Api } from '../../core/api';
import { injectTSDI } from '../../core/tsdi';
import {
    ProductState,
    ProductStateChangeRequestDto,
    ProductUpdateSupportDto
} from '@api/WalletClient';

export function useProductDetailsStore() {
    const { walletClient } = injectTSDI(Api);

    const product = useWrapRequest(
        async (vendorId: number, productId: number) => {
            const result =
                await walletClient.supportApi.vendorSupportControllerGetProductDetails(
                    vendorId,
                    productId
                );
            return result.data;
        },
        {
            defaultData: null
        }
    );

    const updateProduct = useWrapRequest(
        async (
            vendorId: number,
            productId: number,
            data: ProductUpdateSupportDto
        ) => {
            const result =
                await walletClient.supportApi.vendorSupportControllerUpdateProduct(
                    vendorId,
                    productId,
                    data
                );
            return result.data;
        },
        {
            defaultData: null
        }
    );

    const updateProductState = useWrapRequest(
        async (
            vendorId: number,
            productId: number,
            data: ProductStateChangeRequestDto
        ) => {
            const result =
                await walletClient.supportApi.vendorSupportControllerUpdateProductState(
                    vendorId,
                    productId,
                    data
                );
            return result.data;
        },
        {
            defaultData: null
        }
    );

    const handleUpdateProduct = async (
        vendorId: number,
        productId: number,
        data: ProductUpdateSupportDto
    ) => {
        await updateProduct.request([vendorId, productId, data]);
        // Refetch the product details after update
        await product.request([vendorId, productId]);
    };

    const handleUpdateProductState = async (
        vendorId: number,
        productId: number,
        state: ProductState
    ) => {
        await updateProductState.request([vendorId, productId, { state }]);
        // Refetch the product details after state update
        await product.request([vendorId, productId]);
    };

    return {
        product,
        updateProduct,
        updateProductState,
        handleUpdateProduct,
        handleUpdateProductState
    };
}
